module.exports = __webpack_public_path__ + "images/category_lp/watch_samples/sec01_sp_76132ef478e16e755ad368ae8cdf3e26.jpg";